import { Routes, Route } from 'react-router-dom';
import './App.css';
import {
  fetchToken,
  onMessageListener,
  subscribeTokenToTopic,
  unsubscribeTokenFromTopic,
} from './firebase';
import { useEffect, Suspense, useState } from 'react';
import useRedux from './redux/useRedux';
import LoginPage from './views/Auth/login';
import Register from './views/Auth/register';
import RegisterPage from './views/Auth/register.old';
import ForgotPassword from './views/Auth/forgot-password';
import ResetPasswordPage from './views/Auth/reset.password';
import VerifyEmail from './views/Auth/verify-email';
import routes from 'routes';
import { setFirebaseToken, notificationUpdate } from './redux/notification';
import { toast, ToastContainer } from 'react-toastify';
import Sound from './assets/media/audio/notif.mp3';
import { CircularProgress } from '@mui/material';
import ProtectedRoute from 'components/ProtectedRoute/ProtectedRoute';
import PrivateLayout from './components/Layouts/PrivateLayout';
import NotFound from 'views/NotFound';

const loading = <CircularProgress color="success" />;

const App = () => {
  const {
    thunkDispatch,
    storeState: { Auth },
  } = useRedux();
  const [currentMerchantCode, setCurrentMerchantCode] = useState<string | null>(null);

  useEffect(() => {
    if (Auth && Auth.data && Auth.data.data && Auth.data.data.token) {
      fetchToken().then(async (token) => {
        if (token) {
          thunkDispatch(setFirebaseToken(token));

          const newMerchantCode: string = Auth?.data?.data?.merchant?.merchantCode;

          if (currentMerchantCode && currentMerchantCode !== newMerchantCode) {
            console.log(`Unsubscribing from topic: ${currentMerchantCode}`);
            try {
              await unsubscribeTokenFromTopic(token, currentMerchantCode);
              console.log(`Successfully unsubscribed from topic: ${currentMerchantCode}`);
            } catch (error: any) {
              console.error(
                `Failed to unsubscribe from topic: ${currentMerchantCode}, Error: ${error.message}`,
              );
            }
          }

          // Subscribe to the new merchant
          if (newMerchantCode) {
            await subscribeTokenToTopic(token, newMerchantCode);
            setCurrentMerchantCode(newMerchantCode);
          }
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Auth]);

  useEffect(() => {
    console.log("Setting up message listener...");

    const handleMessage = (payload:any) => {
      console.log('Received notification:', payload);
      if (payload) {
        console.log('Current merchant code:', currentMerchantCode); 
        thunkDispatch(notificationUpdate(payload)); 
        toast.success(`Pesanan Baru Masuk!`); 
      } else {
        console.warn('Received payload either undefined or does not contain data.');
      }
    };

    // Set up the message listener
    onMessageListener(handleMessage);

    return () => {
      console.log("Cleaning up message listener...");
    };
  }, [thunkDispatch, currentMerchantCode]); 
  return (
    <Suspense fallback={loading}>
      <ToastContainer style={{ zIndex: '10002' }} />
      <Routes>
        <Route
          path="/"
          element={
            <ProtectedRoute data={Auth}>
              <PrivateLayout key={Auth?.data?.data?.merchant?.id || 'default'} />
            </ProtectedRoute>
          }
        >
          {routes.map((route, idx) => {
            return (
              route.element && <Route key={idx} path={route.path} element={<route.element />} />
            );
          })}
        </Route>

        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<Register />} />
        <Route path="/verify" element={<VerifyEmail />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/404" element={<NotFound />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
};

export default App;
